import { useQuery } from "@tanstack/react-query";

export default function NurtureTemplatePicker({ wsId, lead, onUpdate }: { wsId: number | null; lead: any; onUpdate: (templateId: number | null) => void }) {
  const { data: templates = [] } = useQuery<any[]>({
    queryKey: ["/api/workspaces", wsId, "email-templates"],
    enabled: !!wsId,
    queryFn: async () => {
      const res = await fetch(`/api/workspaces/${wsId}/email-templates`, { credentials: "include" });
      if (!res.ok) return [];
      return res.json();
    },
  });
  if (templates.length === 0) return null;
  const currentTemplateId = (lead as any).templateId || null;
  return (
    <div className="space-y-2">
      <label className="text-[10px] text-muted-foreground/70 uppercase tracking-wider font-bold">Email Template</label>
      <select
        data-testid="select-nurture-template"
        value={currentTemplateId ?? ""}
        onChange={(e) => onUpdate(e.target.value ? Number(e.target.value) : null)}
        className="w-full px-3 py-2 bg-muted/50 border border-border rounded-lg text-xs text-foreground focus:outline-none focus:border-blue-500/40"
      >
        <option value="" className="bg-card">No template</option>
        {templates.map((t: any) => (
          <option key={t.id} value={t.id} className="bg-card">{t.name}</option>
        ))}
      </select>
    </div>
  );
}
